var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7.548 20c9.057 0 14.01-7.694 14.01-14.365 0-.219-.005-.437-.014-.653A10.162 10.162 0 0 0 24 2.368a9.642 9.642 0 0 1-2.828.795A5.046 5.046 0 0 0 23.338.37a9.72 9.72 0 0 1-3.127 1.225A4.863 4.863 0 0 0 16.617 0c-2.72 0-4.925 2.261-4.925 5.049 0 .396.043.781.128 1.15C7.728 5.99 4.099 3.98 1.67.926a5.13 5.13 0 0 0-.666 2.537 5.08 5.08 0 0 0 2.19 4.203 4.796 4.796 0 0 1-2.23-.632v.065c0 2.445 1.697 4.487 3.95 4.95a4.824 4.824 0 0 1-2.224.086c.627 2.006 2.445 3.466 4.6 3.507A9.727 9.727 0 0 1 0 17.732 13.69 13.69 0 0 0 7.548 20"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#40423F",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d0edaf808e1dbc68565af61669d585b9.svg";
export { ForwardRef as ReactComponent };